import React, {useEffect} from "react";
import {LOGIN_MODE_EXPLICIT, useAppApolloClient} from "./apollo-client";
import {ApolloProvider} from "@apollo/client";
import {CircularProgress, Grid} from "@material-ui/core";
import {LoginLogoutContainer} from "@betrue/ui";
import {Skeleton} from "@material-ui/lab";

export interface SecureProviderProps {
  children: React.ReactNode | React.ReactNode[] | null;
  loginMode?: string

}

export const SecureProvider = (props: SecureProviderProps) => {

  const apolloClient = useAppApolloClient(props.loginMode)


  return (<>
      {apolloClient ? (
        <ApolloProvider client={apolloClient}>
          {props.children}
        </ApolloProvider>
      ) : props.loginMode === LOGIN_MODE_EXPLICIT ? (<Grid container direction={"column"} justify={"center"} alignItems={"center"} spacing={3}>
        <Grid item><Skeleton variant="text" />
          <Skeleton variant="circle" width={40} height={40} />
          <Skeleton variant="text" />
          <Skeleton variant="rect" width={210} height={118} />
          <Skeleton variant="text" />
          </Grid>
        <Grid item><LoginLogoutContainer logoutLabel={"Déconnexion"} loginLabel={"Se connecter"} /></Grid>
      </Grid>) : (<CircularProgress />) }
    </>
  )

}


